<template>
<div class="animated fadeIn">

	<div class="row">
		<div class="col-md-12">
			<h3 class="animated slideInDown">
				<fa-icon v-if="form.id != 0" icon="pen-alt"/><fa-icon v-if="form.id == 0" icon="plus"/> Cadastro
			</h3>
		</div>
	</div>

	<div class="row" style="margin-top:1em">
		<div class="col-md-12 col-lg-12">

			<form @submit.prevent="validateBeforeSubmit">
				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Registro:</label>
					<div class="col-sm-10">
						<input type="text"
								name="registro"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('registro')}"
								v-model="form.registro"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('registro')">{{ errors.first('registro') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">IMEI:</label>
					<div class="col-sm-10">
						<input type="text"
								name="imei"
								:class="{'is-invalid' : errors.has('imei')}"
								v-model="form.imei"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('imei')">{{ errors.first('imei') }}</span>
					</div>
				</div>

				<div v-if="_getPrivilegio(9)" class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Equipamento:</label>
					<div class="col-sm-10">
							<toggle-button
										v-model="form.ativo"
										:width="110"
										:height="30"
										:sync="true"
										:value="form.ativo"
										:labels="{checked: 'ATIVADO', unchecked: 'DESATIVADO'}"
										:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Fornecedor:</label>
					<div class="col-sm-8">
						<select v-model="form.fabricante"
								name="fornecedor"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('fornecedor')}"
								class="form-control form-control-sm">
								<option value="">Escolha</option>
								<option value="Rock7">Rock7</option>
								<option value="TrackPlus">TrackPlus</option>
								<option value="SpiderTracks">SpiderTracks</option>
								<option value="FlightCell">FlightCell</option>
								<option value="FlightAware">FlightAware</option>
								<option value="Conor">Conor</option>
								<option value="Geoforce">Geoforce</option>
								<option value="Geotab">Geotab</option>
								<option value="Outros">Outros</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('fornecedor')">{{ errors.first('fornecedor') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Modelo:</label>
					<div class="col-sm-8">
						<select v-model="form.modelo"
								name="modelo"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('modelo')}"
								class="form-control form-control-sm">
								<option value="">Escolha</option>
								<option v-if="form.fabricante == 'SpiderTracks'" value="Spider 8">Spider 8</option>
								<option v-if="form.fabricante == 'SpiderTracks'" value="Spider 7">Spider 7</option>
								<option v-if="form.fabricante == 'SpiderTracks'" value="Spider 6">Spider 6</option>
								<option v-if="form.fabricante == 'SpiderTracks'" value="Spider 5">Spider 5</option>
								<option v-if="form.fabricante == 'SpiderTracks'" value="Spider 3">Spider 3</option>
								<option v-if="form.fabricante == 'Rock7' || form.fabricante == 'TrackPlus'" value="RockAir">RockAir</option>
								<option v-if="form.fabricante == 'Rock7'" value="Chip">Chip</option>
								<option v-if="form.fabricante == 'Rock7'" value="RockBlock">RockBlock</option>
								<option v-if="form.fabricante == 'Rock7'" value="RockFLEET">RockFLEET</option>
								<option v-if="form.fabricante == 'FlightCell'" value="DZMx">DZMx</option>
								<option v-if="form.fabricante == 'FlightAware'" value="ADS-B">ADS-B</option>
								<option v-if="form.fabricante == 'Conor'" value="Suntech St310">Suntech St310</option>
								<option v-if="form.fabricante == 'Geoforce'" value="Geoforce">Geoforce</option>
								<option v-if="form.fabricante == 'Geotab'" value="Geotab">Geotab</option>
								<option v-if="form.fabricante == 'Outros'" value="Tablet">Tablet</option>
								<option v-if="form.fabricante == 'Outros'" value="Celular">Celular</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('modelo')">{{ errors.first('modelo') }}</span>
					</div>
				</div>

				<div class="form-group row" v-if="(form.modelo == 'RockAir' || form.modelo == 'RockFLEET') && _getPrivilegio(9)">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Trecho:</label>
					<div class="col-sm-3">
						<toggle-button
									v-model="form.input"
									:width="110"
									:height="30"
									:sync="true"
									:value="form.input"
									:labels="{checked: 'ATIVO', unchecked: 'DESATIVADO'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
					</div>

					<div class="col-sm-5" v-if="form.input">
						<select v-model="form.tipoInput"
								name="Tipo Input"
								v-validate="form.input ? 'required' : ''"
								:class="{'is-invalid' : errors.has('Tipo Input')}"
								class="form-control form-control-sm">
								<option value="">Escolha</option>
								<option value="STC">STC</option>
								<option value="SISTEMA">SISTEMA</option>
								<option value="IBAMA">IBAMA</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('Tipo Input')">{{ errors.first('Tipo Input') }}</span>
					</div>
				</div>

				<div class="form-group row" v-if="form.modelo == 'RockAir' || form.modelo == 'RockFLEET'">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Renovação:</label>
					<div class="col-sm-3">
						<toggle-button
									v-model="form.renovacao"
									:width="110"
									:height="30"
									:sync="true"
									:value="form.input"
									:labels="{checked: 'AUTOMÁTICA', unchecked: 'MANUAL'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
					</div>

					<div class="col-sm-6" style="margin-top: -7px;" v-if="expiraEm">
						<small>Data Expiração:</small><br/> {{expiraEm}}
					</div>
				</div>
				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Tipo:</label>
					<div class="col-sm-10">
						<select v-model="form.tipo"
								name="tipo"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('tipo')}"
								class="form-control form-control-sm">
							<option value="">Escolha</option>
							<option value="A">Avião</option>
							<option value="H">Helicóptero</option>
							<option value="B">Barco</option>
							<option value="C">Veiculo</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</span>
					</div>	
				</div>
					<div v-if="(form.tipo == 'A' || form.tipo === 'H') && (form.fabricante === 'Rock7' || form.fabricante === 'SpiderTracks') " class="form-group row">
							<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Velocidade decolagem:</label>
							<div class="col-sm-5" >
								<input type="number"
										name="velocidadeDecolagem"
										:class="{'is-invalid' : errors.has('velocidadeDecolagem')}"
										v-model="form.velocidadeDecolagem"
										class="form-control form-control-sm">
									<span class="invalid-feedback" v-show="errors.has('velocidadeDecolagem')">{{ errors.first('velocidadeDecolagem') }}</span>
							</div>
					</div>
					<div  v-if="(form.tipo == 'A' || form.tipo === 'H') && (form.fabricante === 'Rock7' || form.fabricante === 'SpiderTracks') "  class="form-group row">
							<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Velocidade pouso:</label>
							<div class="col-sm-5">
								<input type="number"
										name="velocidadePouso"
										:class="{'is-invalid' : errors.has('velocidadePouso')}"
										v-model="form.velocidadePouso"
										class="form-control form-control-sm">
									<span class="invalid-feedback" v-show="errors.has('velocidadePouso')">{{ errors.first('velocidadePouso') }}</span>
							</div>
					</div>
				<div>
			</div>		
				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Tempo Sistema:</label>
					<div class="col-sm-10">
						<input type="number" v-model="form.tempoSistema" class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('tipoSistema')">{{ errors.first('tipoSistema') }}</span>
					</div>
				</div>
				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Cliente:</label>
					<div class="col-sm-10">
						<select v-model="form.idCliente"
								name="idCliente"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('idCliente')}"
								class="form-control form-control-sm">
							<option value="0">Escolha</option>
							<option v-for="item in clientes" :key="item.id" :value="item.id">{{item.nome}}</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('idCliente')">{{ errors.first('idCliente') }}</span>
					</div>
				</div>
				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Serviço:</label>
					<div class="col-sm-10">
						<select v-model="form.idServico"
								name="idServico"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('idServico')}"
								class="form-control form-control-sm">
							<option value="0">Escolha</option>
							<option v-for="item in servicos" :key="item.id" :value="item.id">{{item.descricao}}</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('idServico')">{{ errors.first('idServico') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Atualização:</label>
					<div class="col-sm-7">
						<select v-model="form.tempoAtualizacao"
								name="tempoAtualizacao"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('tempoAtualizacao')}"
								class="form-control form-control-sm">
							<option value="0">Escolha</option>
							<option v-for="i in 10" :key="i" :value="i">{{i}}</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('tempoAtualizacao')">{{ errors.first('tempoAtualizacao') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label style="line-height: 13px" for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">
						Etiqueta: <br/>
						<small>(Patrimonial)</small>

					</label>
					<div class="col-sm-7">
						<input type="text"
								v-model="form.etiqueta"
								class="form-control form-control-sm">
					</div>
				</div>
				<div class="form-group row">
					<label style="line-height: 13px" for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">
						*Prefixo: <br/>
						<small>(Número)</small>

					</label>
					<div class="col-sm-7">
						<input type="text"
								name="prefixo"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('prefixo')}"
								v-model="form.prefixo"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('prefixo')">{{ errors.first('prefixo') }}</span>
					</div>
				</div>
				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Codinome:</label>
					<div class="col-sm-7">
						<input type="text"
								name="codinome"
								:class="{'is-invalid' : errors.has('codinome')}"
								v-model="form.codinome"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('codinome')">{{ errors.first('codinome') }}</span>
					</div>
				</div>
				<!-- <div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Descrição:</label>
					<div class="col-sm-10">
						<textarea type="text"
								name="descricao"
								:class="{'is-invalid' : errors.has('descricao')}"
								v-model="form.descricao"
								rows="4"
								class="form-control form-control-sm"></textarea>

						<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
					</div>
				</div> -->

				<hr />

				<div class="form-group row">
					<div class="col-sm-12 text-right">
						<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
						<button class="btn btn-success btn-sm">
							<fa-icon icon="check" transform="left-3" /> SALVAR
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
</template>
<script>

import moment from 'moment'
import axios from '../../../routers/axios'
export default {

    data(){
        return {

            clientes: [],
			servicos: [],
			expiraEm: null,
            form: {
                id: 0,
                idCliente: 0,
                idServico: 0,
                tipo: "",
                imei: "",
                prefixo: "",
                codinome: "",
                registro: "",
                modelo: "",
				// descricao: "",
				input: false,
				tipoInput: "",
                tempoAtualizacao: 0,
				tempoSistema: 20,
				ativo: false,
				renovacao: false,
				fabricante: "",
				expiraEm: null,
				etiqueta: "",
            }
        }
    },

    mounted () {

        axios.get(this._getUrl('api/cliente')).then(response => {
            if(response.status == 200){
                this.clientes = response.data
            }
        })

        axios.get(this._getUrl('api/servico')).then(response => {
            if(response.status == 200){
                this.servicos = response.data
            }
        })
    },

    methods: {

        editar(item) {
            this.form.id = item.id
            this.form.idCliente = item.idCliente
            this.form.idServico = item.idServico
            this.form.modelo = item.modelo
            this.form.tipo = item.tipo
            this.form.imei = item.imei
            this.form.registro = item.registro
            this.form.prefixo = item.prefixo
            this.form.codinome = item.codinome
            // this.form.descricao = item.descricao
            this.form.ativo = item.ativo
						this.form.tempoAtualizacao = item.tempoAtualizacao
						this.form.tempoSistema = item.tempoSistema
						this.form.renovacao = item.renovacao
						this.form.fabricante = item.fabricante
						this.form.expiraEm = item.expiraEm
						this.form.tipoInput = item.tipoInput == null ? "" : item.tipoInput
						this.expiraEm = item.expiraEm ? new moment.utc(item.expiraEm).local().locale('pt-br').format("LLL") : null
						this.form.input = item.input
						this.form.etiqueta = item.etiqueta == null ? "" : item.etiqueta
						this.form.velocidadeDecolagem = item.velocidadeDecolagem == null ? "" : item.velocidadeDecolagem
						this.form.velocidadePouso = item.velocidadePouso == null ? "" : item.velocidadePouso
							},

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){
					var data = {
							id : this.form.id,
							idCliente : this.form.idCliente,
							idServico : this.form.idServico,
							modelo : this.form.modelo,
							fabricante: this.form.fabricante,
							tipo : this.form.tipo,
							imei : this.form.imei,
							prefixo : this.form.prefixo,
							codinome : this.form.codinome,
							// descricao : this.form.descricao,
							registro: this.form.registro,
							ativo : this.form.ativo,
							tempoAtualizacao: this.form.tempoAtualizacao,
							tempoSistema: this.form.tempoSistema,
							input: this.form.input,
							renovacao:  this.form.renovacao,
							expiraEm: this.form.expiraEm,
							etiqueta:  this.form.etiqueta,
							tipoInput: this.form.tipoInput,
							velocidadeDecolagem: this.form.velocidadeDecolagem,
							velocidadePouso: this.form.velocidadePouso,

            }

            this.$notify.loadIn('Salvando')

            if(this.form.id != 0){

                axios.put(this._getUrl(`api/equipamento/${this.form.id}`), data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/equipamento'), data).then(response => {
                    this.$emit('item-salvo', response.data)
                    this.form.id = response.data.id
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/cadastro.vue